import React from 'react';

const GameShowsV2 = ({
  className,
  style,
  active
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "18",
    height: "19",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.00017 3.98087L11.4231 0.865723L12.4093 1.63279L10.2783 4.3726H14.8281C16.5532 4.3726 17.9517 5.77105 17.9517 7.49613V15.8255C17.9517 17.5506 16.5532 18.9491 14.8281 18.9491H3.16698C1.44191 18.9491 0.043457 17.5506 0.043457 15.8255V7.49612C0.043457 5.77105 1.44191 4.3726 3.16698 4.3726H7.72202L5.59107 1.63284L6.57729 0.865773L9.00017 3.98087ZM1.29287 7.49612C1.29287 6.46108 2.13194 5.62201 3.16698 5.62201H10.8735V17.6996H3.16698C2.13194 17.6996 1.29287 16.8606 1.29287 15.8255V7.49612ZM12.1229 17.6996H14.8281C15.8632 17.6996 16.7023 16.8606 16.7023 15.8255V7.49613C16.7023 6.46108 15.8632 5.62201 14.8281 5.62201H12.1229V17.6996ZM13.5803 7.49657H15.2462V9.16245H13.5803V7.49657ZM15.2462 10.8281H13.5803V12.494H15.2462V10.8281Z",
      fill: "#B1B6C6"
    }
  )
);

export { GameShowsV2 };
//# sourceMappingURL=GameShowsV2.js.map
